<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VMultiText from "../../Form/Survey/VMultiText.vue";
import VMulti from "../../Form/Survey/VMulti.vue";
import VRadioWithBlockLabel from "../../Form/Survey/VRadioWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";
import intus from "@/Plugins/intus";
import { isRequired, isMin } from "intus/rules";

import { scrollOnError } from "@/Helpers/validation";
import isArrayNoEmptyValue from "../../../Plugins/rules/isArrayNoEmptyValue";

const props = defineProps({
    additional: Object,
    isShowSubmit: {
        Type: Boolean,
        default: true,
    },
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    why_did_you_select_sabah_as_a_holidayvacation_destination:
        answers?.why_did_you_select_sabah_as_a_holidayvacation_destination ??
        [],
    what_influenced_you_to_choose_sabah_as_holidayvacation_destination:
        answers?.what_influenced_you_to_choose_sabah_as_holidayvacation_destination ??
        [],
    how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah:
        answers?.how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah,
    travel_companion: answers?.travel_companion ?? [],
    what_did_you_manage_to_do_during_this_trip_in_sabah:
        answers?.what_did_you_manage_to_do_during_this_trip_in_sabah ?? [],
    where_did_you_stay_during_this_trip:
        answers?.where_did_you_stay_during_this_trip ?? [],
    what_did_you_buy_while_visiting_sabah:
        answers?.what_did_you_buy_while_visiting_sabah ?? [],
    please_specify_your_place_of_shopping:
        answers?.please_specify_your_place_of_shopping ?? [],
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    const validation = intus.validate(
        form.data(),
        {
            why_did_you_select_sabah_as_a_holidayvacation_destination: [
                isRequired(),
                isMin(1),
                isArrayNoEmptyValue(),
            ],
            what_influenced_you_to_choose_sabah_as_holidayvacation_destination:
                [isRequired(), isMin(1), isArrayNoEmptyValue()],
            how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah:
                [isRequired()],
            travel_companion: [isRequired(), isMin(1), isArrayNoEmptyValue()],
            what_did_you_manage_to_do_during_this_trip_in_sabah: [
                isRequired(),
                isMin(1),
                isArrayNoEmptyValue(),
            ],
            where_did_you_stay_during_this_trip: [
                isRequired(),
                isArrayNoEmptyValue(),
            ],
            what_did_you_buy_while_visiting_sabah: [isRequired()],
            please_specify_your_place_of_shopping: [
                isRequired(),
                isArrayNoEmptyValue(),
            ],
        },
        {
            ...intus.messages,
            why_did_you_select_sabah_as_a_holidayvacation_destination:
                surveyFields[
                    "why_did_you_select_sabah_as_a_holidayvacation_destination"
                ]?.name,
            what_influenced_you_to_choose_sabah_as_holidayvacation_destination:
                surveyFields[
                    "what_influenced_you_to_choose_sabah_as_holidayvacation_destination"
                ]?.name,
            how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah:
                surveyFields[
                    "how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah"
                ]?.name,
            travel_companion: surveyFields["travel_companion"]?.name,
            what_did_you_manage_to_do_during_this_trip_in_sabah:
                surveyFields[
                    "what_did_you_manage_to_do_during_this_trip_in_sabah"
                ]?.name,
            where_did_you_stay_during_this_trip:
                surveyFields["where_did_you_stay_during_this_trip"]?.name,
            what_did_you_buy_while_visiting_sabah:
                surveyFields["what_did_you_buy_while_visiting_sabah"]?.name,
            please_specify_your_place_of_shopping:
                surveyFields["please_specify_your_place_of_shopping"]?.name,
        }
    );

    form.clearErrors();
    if (validation.passes()) {
        emits("onNext", form.data());
    } else {
        form.setError(validation.errors());
        setTimeout(() => scrollOnError(), 300);
    }
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-4">
                    <VMultiText
                        elId="why_did_you_select_sabah_as_a_holidayvacation_destination"
                        v-model:value="
                            form.why_did_you_select_sabah_as_a_holidayvacation_destination
                        "
                        :label="
                            surveyFields[
                                'why_did_you_select_sabah_as_a_holidayvacation_destination'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'why_did_you_select_sabah_as_a_holidayvacation_destination'
                            ]?.options
                        "
                        :otherOptionLabel="
                            surveyFields[
                                'why_did_you_select_sabah_as_a_holidayvacation_destination'
                            ]?.config['other_label']
                        "
                        :otherOptionPlaceholder="
                            surveyFields[
                                'why_did_you_select_sabah_as_a_holidayvacation_destination'
                            ]?.config['other_label']
                        "
                        :error="
                            form.errors
                                ?.why_did_you_select_sabah_as_a_holidayvacation_destination
                        "
                    />
                </div>
                <div class="mb-4">
                    <VMultiText
                        elId="what_influenced_you_to_choose_sabah_as_holidayvacation_destination"
                        v-model:value="
                            form.what_influenced_you_to_choose_sabah_as_holidayvacation_destination
                        "
                        :label="
                            surveyFields[
                                'what_influenced_you_to_choose_sabah_as_holidayvacation_destination'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'what_influenced_you_to_choose_sabah_as_holidayvacation_destination'
                            ]?.options
                        "
                        :otherOptionLabel="
                            surveyFields[
                                'what_influenced_you_to_choose_sabah_as_holidayvacation_destination'
                            ]?.config['other_label']
                        "
                        :otherOptionPlaceholder="
                            surveyFields[
                                'what_influenced_you_to_choose_sabah_as_holidayvacation_destination'
                            ]?.config['other_label']
                        "
                        :error="
                            form.errors
                                ?.what_influenced_you_to_choose_sabah_as_holidayvacation_destination
                        "
                    />
                </div>
                <div class="mb-4">
                    <VRadioWithBlockLabel
                        elId="how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah"
                        v-model:value="
                            form.how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah
                        "
                        :label="
                            surveyFields[
                                'how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah'
                            ]?.options.map((value) => {
                                return { id: value, description: value };
                            })
                        "
                        :error="
                            form.errors
                                ?.how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah
                        "
                    />
                </div>
                <div class="mb-4">
                    <VMultiText
                        elId="travel_companion"
                        v-model:value="form.travel_companion"
                        :label="surveyFields['travel_companion']?.name"
                        :options="surveyFields['travel_companion']?.options"
                        :otherOptionLabel="
                            surveyFields['travel_companion']?.config[
                                'other_label'
                            ]
                        "
                        :error="form.errors?.travel_companion"
                        ,
                    />
                </div>
                <div class="mb-4">
                    <VMultiText
                        elId="what_did_you_manage_to_do_during_this_trip_in_sabah"
                        v-model:value="
                            form.what_did_you_manage_to_do_during_this_trip_in_sabah
                        "
                        :label="
                            surveyFields[
                                'what_did_you_manage_to_do_during_this_trip_in_sabah'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'what_did_you_manage_to_do_during_this_trip_in_sabah'
                            ]?.options
                        "
                        :otherOptionLabel="
                            surveyFields[
                                'what_did_you_manage_to_do_during_this_trip_in_sabah'
                            ]?.config['other_label']
                        "
                        :otherOptionPlaceholder="
                            surveyFields[
                                'what_did_you_manage_to_do_during_this_trip_in_sabah'
                            ]?.config['other_label']
                        "
                        :error="
                            form.errors
                                ?.what_did_you_manage_to_do_during_this_trip_in_sabah
                        "
                    />
                </div>
                <div class="mb-4">
                    <VMultiText
                        elId="where_did_you_stay_during_this_trip"
                        v-model:value="form.where_did_you_stay_during_this_trip"
                        :label="
                            surveyFields['where_did_you_stay_during_this_trip']
                                ?.name
                        "
                        :options="
                            surveyFields['where_did_you_stay_during_this_trip']
                                ?.options
                        "
                        :otherOptionLabel="
                            surveyFields['where_did_you_stay_during_this_trip']
                                ?.config['other_label']
                        "
                        :otherOptionPlaceholder="
                            surveyFields['where_did_you_stay_during_this_trip']
                                ?.config['other_label']
                        "
                        :error="
                            form.errors?.where_did_you_stay_during_this_trip
                        "
                    />
                </div>
                <div class="mb-4">
                    <VMulti
                        elId="what_did_you_buy_while_visiting_sabah"
                        v-model:value="
                            form.what_did_you_buy_while_visiting_sabah
                        "
                        :label="
                            surveyFields[
                                'what_did_you_buy_while_visiting_sabah'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'what_did_you_buy_while_visiting_sabah'
                            ]?.options
                        "
                        :error="
                            form.errors?.what_did_you_buy_while_visiting_sabah
                        "
                    />
                </div>
                <div class="mb-4">
                    <VMultiText
                        elId="please_specify_your_place_of_shopping"
                        v-model:value="
                            form.please_specify_your_place_of_shopping
                        "
                        :label="
                            surveyFields[
                                'please_specify_your_place_of_shopping'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'please_specify_your_place_of_shopping'
                            ]?.options
                        "
                        :otherOptionLabel="
                            surveyFields[
                                'please_specify_your_place_of_shopping'
                            ]?.config['other_label']
                        "
                        :otherOptionPlaceholder="
                            surveyFields[
                                'please_specify_your_place_of_shopping'
                            ]?.config['other_label']
                        "
                        :error="
                            form.errors?.please_specify_your_place_of_shopping
                        "
                    />
                </div>
            </div>
        </div>
        <VDevider />
        <div class="text-end" v-if="isShowSubmit">
            <VButtonSubmit type="button" @onCLickSubmit="handleClickNext">
                {{ $t("public.page.survey.button.next") }}
            </VButtonSubmit>
        </div>
    </div>
</template>
